// extracted by mini-css-extract-plugin
export default {"flashArticle":"flash-highlight_flashArticle__cwKM8"};